import { hot } from 'react-hot-loader/root';
import React from 'react';

import PageSection from '../design-system/PageSection';
import PageWrapper from '../design-system/PageWrapper';
import Container from '../design-system/Containers';
import Paragraph from '../design-system/Paragraph';
import { HeadingArticle } from '../design-system/Headings';

const PotentialPage = () => (
  <PageWrapper tallNav bgDark>
    <PageSection bgDarkMid container={false}>
      <Container className="ss_container--small">
        <HeadingArticle el="h1">Potential</HeadingArticle>
        <Paragraph headlineFeature uppercase secondary>Coming Soon</Paragraph>
        <Paragraph intro>
          This section will soon offer you insights into ways to further develop
          upon your specific attributes identified by the SPYCHOLOGY program.
        </Paragraph>
      </Container>
    </PageSection>
  </PageWrapper>
);

export default hot(PotentialPage);
